// @flow

import styled from 'styled-components';

const Head = styled.div`
  /* style me here, if you must */
`;

export default Head;
